"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var qrcode_vue_1 = require("qrcode.vue");
var ClientShareUrlQrCode = /** @class */ (function (_super) {
    __extends(ClientShareUrlQrCode, _super);
    function ClientShareUrlQrCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = _this.getSharingUri_();
        _this.size = 190;
        return _this;
    }
    ClientShareUrlQrCode.prototype.getSharingUri_ = function () {
        console.log("******");
        console.log(location.protocol + "//" + location.host + "/" + this.getOfficeId());
        return location.protocol + "//" + location.host + "/" + this.getOfficeId();
    };
    ClientShareUrlQrCode.prototype.getOfficeId = function () {
        return this.$route.params['office_id'];
    };
    ClientShareUrlQrCode = __decorate([
        vue_property_decorator_1.Component({
            components: {
                QrcodeVue: qrcode_vue_1.default
            }
        })
    ], ClientShareUrlQrCode);
    return ClientShareUrlQrCode;
}(vue_property_decorator_1.Vue));
exports.default = ClientShareUrlQrCode;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/qrcode/ClientShareUrlQrCode.vue
// module id = SYYY
// module chunks = 1